/**
 * FitProfiles Queries
 */
import gql from 'graphql-tag'

export const getFitProfileQuery = gql`
  query getUserFitProfiles {
    fitProfiles: getUserFitProfiles {
      id
      shortId: short_id
      email
      startedAt: started_at
      status
      userId: user_id
      userShortId: user_short_id
      firstName: first_name
      lastName: last_name
      accountManager: account_manager
      unit
      gender
      height
      weight
      completedAt: completed_at
      measurements
      inputMethod: input_method
      bodyModel: body_model
    }
  }
`

export const sendSizeRecRequestMutation = gql`
  mutation sendSizeRecRequest($input: SizeRecInput!) {
    sendSizeRecRequest(input: $input) {
      message
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FitProfiles/data.ts